//export const BASE_URL = 'https://localhost:7161'
//export const BASE_URL = 'http://161.97.111.59:18081'
export const BASE_URL = 'https://api.zapisy.jpm.umed.pl'